import React from 'react'
import s from './AboutSection.module.scss'
import { ReactComponent as StudentIcon } from 'assets/icons/student.svg'
import { ReactComponent as HeartIcon } from 'assets/icons/heart.svg'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'

const AboutSection = ({ data, isLoading = false, careerInterests = [] }) => {
	const {
		careerAspirations,
		researchInterests,
		whyAbroad,
		intendedMajor,
		otherTestScore,
		languagesSpoken,
	} = data || {}

	const aboutText = careerAspirations || researchInterests || whyAbroad || ''

	const majorLabel =
		typeof intendedMajor === 'string' ? intendedMajor : intendedMajor?.label

	const interests = [
		...new Set(
			[
				...(Array.isArray(careerInterests) ? careerInterests : []),
				majorLabel,
				otherTestScore,
				languagesSpoken,
			].filter(Boolean),
		),
	]

	return (
		<section className={s.card}>
			<div className={s.head}>
				<span className={s.head__icon}>
					<StudentIcon />
				</span>
				<h3 className={s.head__title}>About</h3>
			</div>

			{isLoading ? (
				<span className={`${s.loader} ${s.loaderText}`}>
					<LoaderImg />
				</span>
			) : aboutText ? (
				<p className={s.text}>{aboutText}</p>
			) : (
				<p className={s.empty}>
					Student hasn't added a description about themselves yet.
				</p>
			)}

			<div className={s.interests}>
				<div className={s.interests__head}>
					<span className={s.interests__icon}>
						<HeartIcon />
					</span>
					<span className={s.interests__label}>Interests & Focus Areas</span>
				</div>
				{isLoading ? (
					<div className={s.tags}>
						{[0, 1, 2].map(index => (
							<span key={index} className={`${s.loader} ${s.loaderTag}`}>
								<LoaderImg />
							</span>
						))}
					</div>
				) : interests.length > 0 ? (
					<div className={s.tags}>
						{interests.map((item, index) => (
							<span key={index} className={s.tag}>
								{item}
							</span>
						))}
					</div>
				) : (
					<p className={s.empty}>Student hasn't added interests yet.</p>
				)}
			</div>
		</section>
	)
}

export default AboutSection
